/**
 * TOV Spaces Homepage — Featured Products Popup
 */
class TovSpacesPopup {
  constructor() {
    this.overlay = document.getElementById('tov-spaces-popup-overlay');
    if (!this.overlay) return;

    this.popup = this.overlay.querySelector('.tov-spaces__popup');
    this.titleEl = this.overlay.querySelector('.tov-spaces__popup-title');
    this.listEl = this.overlay.querySelector('.tov-spaces__popup-list');
    this.closeBtn = this.overlay.querySelector('.tov-spaces__popup-close');

    this.bindEvents();
  }

  bindEvents() {
    // Open triggers
    document.querySelectorAll('.tov-spaces__products-trigger').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.open(btn);
      });
    });

    // Close
    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay.classList.contains('is-active')) {
        this.close();
      }
    });
  }

  open(triggerBtn) {
    const spaceName = triggerBtn.dataset.spaceName || '';
    const variantsJson = triggerBtn.dataset.variants || '[]';
    let variants = [];

    try {
      variants = JSON.parse(variantsJson);
    } catch (err) {
      console.error('[TOV Spaces] Failed to parse variants:', err);
      return;
    }

    if (!variants.length) return;

    this.titleEl.textContent = spaceName;
    this.listEl.innerHTML = '';

    variants.forEach((v) => {
      const row = document.createElement('div');
      row.className = 'tov-spaces__product-row';
      row.innerHTML = `
        ${v.image ? `<img src="${v.image}" alt="${this.escapeHtml(v.title)}" class="tov-spaces__product-image" width="60" height="60" loading="lazy">` : '<div class="tov-spaces__product-image" style="background:#f0f0f0;"></div>'}
        <div class="tov-spaces__product-info">
          <p class="tov-spaces__product-name">${this.escapeHtml(v.title)}</p>
          ${v.variant_title ? `<p class="tov-spaces__product-variant-name">${this.escapeHtml(v.variant_title)}</p>` : ''}
        </div>
        <button type="button" class="tov-spaces__product-atc" data-variant-id="${v.variant_id}">Add to Cart</button>
      `;
      this.listEl.appendChild(row);
    });

    // Bind add-to-cart buttons
    this.listEl.querySelectorAll('.tov-spaces__product-atc').forEach((btn) => {
      btn.addEventListener('click', () => this.addToCart(btn));
    });

    this.overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  async addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      });

      if (!res.ok) throw new Error('Add to cart failed');

      btn.textContent = 'Added ✓';
      btn.classList.add('tov-spaces__product-atc--added');

      // Trigger cart update for the theme
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tov-spaces', cartData });
      }

      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.classList.remove('tov-spaces__product-atc--added');
        btn.disabled = false;
      }, 2000);
    } catch (err) {
      console.error('[TOV Spaces] Add to cart error:', err);
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 2000);
    }
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new TovSpacesPopup();
});
